export function hubChatDisplayName({ name, type, orgName }) {
  const suffix = name && name !== 'unnamed chat'
    ? name
    : type === 'public_hub_chat' ? 'General'
    : type === 'private_hub_chat' ? 'Private Chat'
    : type
  return `${orgName} - ${suffix}`
}
